import { useAtomValue } from 'jotai';

import { oddsPageAtom, isOddsPageLoadingAtom } from '@/atoms/odds-page';
import { Maybe } from '@nf/utils-common/fpw/monadic';
import { objectEmptyCheck } from '@nf/utils-common/fpw/utils';

import { SportPageWrapper } from '../sport-page-wrapper';

export const MatchesViewWrapper = (
	{ isThirdParty, children }:
		{
			isThirdParty: boolean,
			children: React.ReactNode
		}) => {
	const isLoading = useAtomValue(isOddsPageLoadingAtom);
	const oddsData = useAtomValue(oddsPageAtom);
	
	const hasData: boolean = 
		!Maybe(oddsData)
			.chain(objectEmptyCheck)
			.isLeft;

	return (
		<SportPageWrapper
			isLoading={isLoading}
			hasData={hasData}
			isThirdParty={isThirdParty}
		>
			{children}
		</SportPageWrapper>
	);
};